export type LayoutMode = "mobile" | "wide";

export const WIDE_MIN_WIDTH = 900;
export const WIDE_MIN_HEIGHT = 600;

export function modeForViewport(width: number, height: number): LayoutMode {
  return width >= WIDE_MIN_WIDTH && height >= WIDE_MIN_HEIGHT ? "wide" : "mobile";
}
